module.exports = __webpack_public_path__ + "img/image9.c3ad3caa.jpg";